import { colors } from "../colors";

let bmodeOptions = (theme) => ({
  chart: {
    type: "line",
    backgroundColor: null,
    plotBackgroundImage: "",
    animation: false,
    plotBorderWidth: 0,
    marginRight: 80, // determine the distance between graph and color bar
  },
  credits: {
    enabled: false,
  },
  title: {
    text: null,
    style: {
      color: colors.chartTitle,
    },
  },
  yAxis: {
    title: {
      text: "Depth (mm)",
      offset: -30,
      useHTML: true,
      style: {
        color: colors.chartAxisLabel,
        "border-radius": "4px",
        padding: "5px",
        "background-color": colors.chartAxisBkg,
      },
    },
    labels: {
      // format: "{value}",
      formatter: null,
      step: 5,
      style: {
        color: colors.chartAxisLabel,
      },
    },
    startOnTick: true,
    endOnTick: true,
    reversed: true,
    min: 0,
    max: 15,
    tickWidth: 1,
    lineWidth: 1, // y-axis line
    gridLineWidth: 0,
    minorGridLineWidth: 0,
    // tickPixelInterval: 25,
    tickInterval: 0.2,

    plotLines: [
      {
        // Skin surfae (line)
        color: colors[theme].secondary,
        width: 3,
        dashStyle: "dash",
        value: 0,
        zIndex: 10,
        className: "skinLineStart skinThicknessLine",
      },
      {
        // Skin surface (region)
        color: colors.bmodeLineBkg,
        width: 25,
        value: 0,
        zIndex: 9,
        className: "skinRegionStart skinThicknessRegion",
      },
      {
        // Skin bottom (line)
        color: colors[theme].secondary,
        width: 3,
        dashStyle: "dash",
        value: 0,
        zIndex: 10,
        className: "skinLineEnd skinThicknessLine",
      },
      {
        // Skin bottom (region)
        color: colors.bmodeLineBkg,
        width: 25,
        value: 0,
        zIndex: 9,
        className: "skinRegionEnd skinThicknessRegion",
      },
    ],
  },
  xAxis: {
    title: {
      text: "Frame",
      offset: -30,
      useHTML: true,
      style: {
        color: colors.chartAxisLabel,
        "border-radius": "4px",
        padding: "5px",
        "background-color": colors.chartAxisBkg,
      },
    },
    labels: {
      format: "{value}",
      style: {
        color: colors.chartAxisLabel,
      },
    },
    startOnTick: false,
    endOnTick: false,
    min: 0,
    max: 150,
    allowDecimals: false,
    tickPixelInterval: 25,
  },
  colorAxis: {
    min: -40,
    max: 0,
    minColor: "white",
    maxColor: "black",
    startOnTick: false,
    endOnTick: false,
    labels: {
      // format: "{value} dB",
      formatter: function () {
        let newValue = this.value * -1;
        return `${newValue} dB`;
      },
      x: 3, // distance between color bar and colorbar label
      style: {
        color: colors.chartAxisLabel,
      },
    },
    tickInterval: 5, // The interval of the tick marks in axis units
  },
  legend: {
    layout: "vertical",
    verticalAlign: "top",
    align: "right",
    symbolHeight: 260, // height of the color bar
    symbolPadding: 10,
    // backgroundColor: "red",
    y: -8,
    title: {
      text: "Amplitude",
      style: {
        fontSize: "11px",
        fontWeight: "unset",
        color: colors.chartAxisLabel,
      },
    },
  },
  series: [
    {
      name: "Bmode",
      type: "line",
      borderWidth: 0,
      animation: false,
      nullColor: colors.chartNullColor,
      tooltip: {
        enabled: false,
      },
    },
  ],
});

export { bmodeOptions };
